(function () {
  var ENDPOINT = '/apps/janine-form-submissions';
  var PENDING_KEY = 'janinePendingFormSubmission';

  function statusElement(wrapper) {
    return wrapper.querySelector('[data-janine-submission-status]');
  }

  function statusMessage(wrapper, type) {
    if (type === 'success') return wrapper.dataset.janineSuccessMessage;
    if (type === 'error') return wrapper.dataset.janineErrorMessage;
    return wrapper.dataset.janineSubmittingMessage;
  }

  function showStatus(wrapper, type) {
    var output = statusElement(wrapper);
    if (!output) return;
    output.textContent = statusMessage(wrapper, type) || '';
    output.hidden = false;
    output.classList.toggle('ja-form__error', type === 'error');
    output.classList.toggle('ja-form__message--pending', type === 'pending');
    output.setAttribute('role', type === 'error' ? 'alert' : 'status');
  }

  function savePending(form, submissionId) {
    try {
      window.sessionStorage.setItem(PENDING_KEY, JSON.stringify({
        formId: form.id,
        submissionId: submissionId,
        path: window.location.pathname,
        createdAt: Date.now()
      }));
    } catch (error) {
      console.warn('Unable to remember the submitted Janine form.', error);
    }
  }

  function readPending() {
    try {
      return JSON.parse(window.sessionStorage.getItem(PENDING_KEY) || 'null');
    } catch (error) {
      return null;
    }
  }

  function clearPending() {
    try {
      window.sessionStorage.removeItem(PENDING_KEY);
    } catch (error) {
      console.warn('Unable to clear the submitted Janine form status.', error);
    }
  }

  function restoreStatus() {
    var params = new URLSearchParams(window.location.search);
    var pending = readPending();
    var hashId = decodeURIComponent(window.location.hash.replace(/^#/, ''));
    var formId = pending && pending.path === window.location.pathname
      ? pending.formId
      : hashId;
    if (!formId) return;

    var form = document.getElementById(formId);
    var wrapper = form && form.closest('[data-janine-submission-wrapper]');
    if (!form || !wrapper || !statusElement(wrapper)) return;

    if (params.get('contact_posted') === 'true') {
      showStatus(wrapper, 'success');
      clearPending();
    } else if (
      pending &&
      pending.path === window.location.pathname &&
      Date.now() - Number(pending.createdAt || 0) < 10 * 60 * 1000
    ) {
      delete form.dataset.janineNativeSubmit;
      clearPending();
      if (!pending.submissionId) return;
      showStatus(wrapper, 'success');
    } else {
      return;
    }

    if (wrapper.dataset.janineStatusRestored !== 'true') {
      wrapper.dataset.janineStatusRestored = 'true';
      window.requestAnimationFrame(function () {
        wrapper.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'center'
        });
      });
    }
  }

  function addContactField(form, label, value) {
    if (!value) return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'contact[' + label + ']';
    input.value = value;
    form.appendChild(input);
  }

  function nativeSubmit(form, submitter) {
    form.dataset.janineNativeSubmit = 'true';
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(submitter || undefined);
      return;
    }
    HTMLFormElement.prototype.submit.call(form);
  }

  function bindShowroom(form) {
    var visit = form.querySelector('[data-janine-showroom-visit]');
    var field = form.querySelector('[data-janine-showroom-field]');
    var showroom = form.querySelector('[data-janine-showroom-select]');
    if (!visit || !field || !showroom) return;
    var dependents = Array.from(form.querySelectorAll('[data-janine-showroom-dependent]'));
    dependents.forEach(function (group) {
      group.querySelectorAll('input, select').forEach(function (input) {
        input.dataset.showroomRequired = String(input.required);
      });
    });
    function update() {
      var yes = visit.value === 'Yes';
      field.hidden = !yes;
      showroom.disabled = !yes;
      showroom.required = yes;
      if (!yes) showroom.value = '';
      dependents.forEach(function (group) {
        group.hidden = !yes;
        group.querySelectorAll('input, select').forEach(function (input) {
          input.disabled = !yes;
          input.required = yes && input.dataset.showroomRequired === 'true';
          if (!yes) input.value = '';
        });
      });
      form.querySelectorAll('.select-wrapper').forEach(function (wrapper) {
        var select = wrapper.querySelector('select'), display = wrapper.querySelector('.selected-text');
        if (select && display) display.textContent = select.options[select.selectedIndex < 0 ? 0 : select.selectedIndex].textContent;
      });
    }
    visit.addEventListener('change', update);
    form.addEventListener('reset', function () { window.setTimeout(update, 0); });
    window.addEventListener('pageshow', update);
    update();
  }

  function bindForm(wrapper) {
    var form = wrapper.matches('form') ? wrapper : wrapper.querySelector('form');
    if (!form || form.dataset.janineSubmissionReady === 'true') return;
    form.dataset.janineSubmissionReady = 'true';
    bindShowroom(form);

    form.addEventListener('submit', function (event) {
      if (form.dataset.janineNativeSubmit === 'true') return;
      event.preventDefault();
      event.stopPropagation();

      var hasInlineStatus = Boolean(statusElement(wrapper));
      var submissionId = null;
      clearPending();
      if (hasInlineStatus) showStatus(wrapper, 'pending');

      var button = form.querySelector('button[type="submit"], input[type="submit"]');
      var originalDisabled = button ? button.disabled : false;
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      }

      var formData = new FormData(form);
      formData.set('janine_source_url', window.location.href);
      var controller = new AbortController();
      var timeout = window.setTimeout(function () { controller.abort(); }, 15000);

      fetch(ENDPOINT, {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        signal: controller.signal
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Submission archive returned ' + response.status);
          return response.json();
        })
        .then(function (result) {
          if (result && result.submissionId) {
            submissionId = result.submissionId;
            addContactField(form, 'Submission reference', result.submissionId);
          }
          if (result && result.attachments && result.attachments.length) {
            addContactField(
              form,
              'Attachments stored in Shopify Admin',
              result.attachments.join(', ')
            );
          }
          window.clearTimeout(timeout);
          if (button) {
            button.disabled = originalDisabled;
            button.removeAttribute('aria-busy');
          }
          if (hasInlineStatus && submissionId) {
            savePending(form, submissionId);
            showStatus(wrapper, 'success');
          }
          nativeSubmit(form, button);
        })
        .catch(function (error) {
          window.clearTimeout(timeout);
          if (button) {
            button.disabled = originalDisabled;
            button.removeAttribute('aria-busy');
          }
          if (hasInlineStatus) {
            console.warn(submissionId ? 'Janine enquiry saved; Shopify contact step interrupted.' : 'Janine submission failed.', error);
            showStatus(wrapper, submissionId ? 'success' : 'error');
            delete form.dataset.janineNativeSubmit;
            return;
          }
          console.warn('Janine submission archive unavailable; continuing with Shopify email.', error);
          nativeSubmit(form, button);
        });
    });
  }

  function init(root) {
    root.querySelectorAll('[data-janine-submission-wrapper]').forEach(bindForm);
    root.querySelectorAll('input[name="janine_theme_id"]').forEach(function (input) {
      if (input.form) bindForm(input.form);
    });
    restoreStatus();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  window.addEventListener('pageshow', restoreStatus);
})();
